import { useMutation } from "react-query"
import { API } from "../api"

export const useAddOrderNotes = () => useMutation(API.addOrderNotes);
